import { createContext, useContext, useState, ReactNode } from "react";

interface FormDesignerContextType {
  isDesignerOpen: boolean;
  setIsDesignerOpen: (open: boolean) => void;
}

const FormDesignerContext = createContext<FormDesignerContextType>({
  isDesignerOpen: false,
  setIsDesignerOpen: () => {},
});

export function FormDesignerProvider({ children }: { children: ReactNode }) {
  const [isDesignerOpen, setIsDesignerOpen] = useState(false);

  return (
    <FormDesignerContext.Provider value={{ isDesignerOpen, setIsDesignerOpen }}>
      {children}
    </FormDesignerContext.Provider>
  );
}

export function useFormDesigner() {
  return useContext(FormDesignerContext);
}
